<template>
  <div class="w-full">
    <div class="mb-4 relative group">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
        <x-icons name="search" class="text-[20px]" />
      </div>
      <input 
        type="text" 
        v-model="searchQuery"
        class="block w-full p-2 pl-10 text-sm text-text-main border border-border rounded-lg bg-background-light focus:ring-primary focus:border-primary placeholder-gray-400 transition-colors" 
        :placeholder="searchPlaceholder"
        autocomplete="off"
      />
    </div>

    <div class="space-y-2">
      <label 
        v-for="brand in visibleBrands" 
        :key="brand.id" 
        class="flex items-center gap-3 cursor-pointer group select-none"
      >
        <input 
          type="checkbox" 
          :value="brand.id"
          v-model="selectedBrands"
          @change="emitSelection"
          class="rounded border-gray-300 text-primary focus:ring-primary w-4 h-4" 
        />

        <div class="flex items-center gap-2 flex-grow overflow-hidden">
          <span class="text-sm text-text-main group-hover:text-primary truncate">
            {{ brand.name }}
          </span>
        </div>
      </label>
    </div>

    <div v-if="filteredBrands.length === 0" class="mt-2 text-sm text-gray-500 italic">
      {{ noResultsText }}
    </div>

    <div class="mt-3 flex justify-center" v-if="shouldShowToggle">
      <button 
        @click="showAll = !showAll"
        class="flex items-center gap-2 px-3 py-2 rounded-md font-semibold text-text-main hover:bg-primary-50 hover:text-primary text-sm font-bold transition-colors">
        {{ showAll ? textShowLess : textShowMore }}
        <x-icons name="expand_more" class="transition-transform duration-200 text-[20px]" 
          :class="{
            'rotate-180': showAll
          }" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandFilter",
  props: {
    // Los datos de las marcas
    brands: {
      type: Array,
      default: () => [],
    },
    // V-model para las marcas seleccionadas (array de IDs). En Vue 3 el
    // v-model de un componente es `modelValue` + `update:modelValue`
    // (en Vue 2 era `value` + `input`).
    modelValue: {
      type: Array,
      default: () => [],
    },
    // Textos traducidos
    title: { type: String, default: "Brands" },
    searchPlaceholder: { type: String, default: "Buscar marca..." },
    textShowMore: { type: String, default: "Ver más" },
    textShowLess: { type: String, default: "Ver menos" },
    noResultsText: { type: String, default: "No existen resultados" },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      searchQuery: "",
      selectedBrands: this.modelValue || [], // Sincronizado con props
      showAll: false,
      limit: 10,
    };
  },
  watch: {
    modelValue(newVal) {
      this.selectedBrands = newVal;
    }
  },
  computed: {
    // 1. Filtrar por búsqueda
    filteredBrands() {
      if (!this.searchQuery) return this.brands;
      
      const query = this.searchQuery.toLowerCase();
      return this.brands.filter(b => 
        b.name.toLowerCase().includes(query)
      );
    },
    // 2. Aplicar límite de "Ver más"
    visibleBrands() {
      if (this.showAll) {
        return this.filteredBrands;
      }
      return this.filteredBrands.slice(0, this.limit);
    },
    // 3. Decidir si mostrar el botón
    shouldShowToggle() {
      return this.filteredBrands.length > this.limit;
    }
  },
  methods: {
    emitSelection() {
      // Emitimos el cambio al padre
      this.$emit('update:modelValue', this.selectedBrands); // Para v-model
      this.$emit('change', this.selectedBrands); // Evento extra por si acaso
    },
    getBrandInitial(name) {
      return name ? name.charAt(0).toUpperCase() : '?';
    }
  }
};
</script>